import { render } from "./Callback_saml.vue?vue&type=template&id=59a89dd6"
import script from "./Callback_saml.vue?vue&type=script&lang=js"
export * from "./Callback_saml.vue?vue&type=script&lang=js"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__